<div class="modal-body p-30px">
  <div class="cross-btn pointer" (click)="onCloseAction()">
    <itax-icon [name]="'close'" [color]="'#454c60'" [size]="'20px'"></itax-icon>
  </div>
  <div class="text-center">
    <div>
      <img src="../../../../../../assets/images/ico-caution-3-d.png" width="100" height="100"/>
    </div>
    <div class="p1 font-weight-bold my-10px">
      Save ข้อมูลก่อน
    </div>
    <div class="p text-gray-medium">
      กรุณา save ข้อมูลก่อนเพื่อป้องกันข้อมูลหาย
    </div>
  </div>
  <div class="w-100 d-flex justify-content-end mt-30px">
    <button type="button" class="btn btn-gray-no-border py-10px" (click)="onCancel()">
      Don’t save
    </button>
    <button type="button" class="btn btn-primary py-10px px-40px ml-30px btn-confirm" (click)="onConfirm()">
      Save
    </button>
  </div>
</div>
